import { isStorybook } from '@vrplatform/data';
import { pdf as renderPdf } from '@react-pdf/renderer';
import type { ReactElement } from 'react';

export const renderPdfToBlob = async (document: ReactElement) => {
  if (isStorybook) {
    // Storybook validates the export interaction flow, while the browser PDF
    // renderer can hang indefinitely in that environment.
    return new Blob(['storybook-pdf'], { type: 'application/pdf' });
  }

  return renderPdf(document).toBlob();
};
